/**
 * Spec 051 · WhatsApp de operación. Filas nombre + móvil.
 */
const NUEVE = /^[567]\d{8}$/

export interface FilaOperador {
    telefono: string
    nombre: string
}

export function nueveDigitosOperador(raw: string): string | null {
    const d = raw.replace(/\D/g, '').slice(-9)
    return NUEVE.test(d) ? d : null
}

export function normalizarFilas(
    filas: readonly FilaOperador[],
): { ok: true; operadores: FilaOperador[] } | { ok: false; error: string } {
    const porTelefono = new Map<string, string>()
    for (const fila of filas) {
        const nombre = fila.nombre.trim()
        const telRaw = fila.telefono.trim()
        if (telRaw === '' && nombre === '') continue
        const n = nueveDigitosOperador(telRaw)
        if (!n) {
            return { ok: false, error: `"${telRaw || nombre}" no es un móvil de nueve dígitos (5, 6 o 7)` }
        }
        porTelefono.set(n, nombre.slice(0, 80))
    }
    return {
        ok: true,
        operadores: [...porTelefono.entries()].map(([telefono, nombre]) => ({ telefono, nombre })),
    }
}

export function filaVacia(): FilaOperador {
    return { telefono: '', nombre: '' }
}
